import { createSlice } from "@reduxjs/toolkit";

const INIT_VALUE = {
  attemptType: "best"
};

const AssessmentReportSlice = createSlice({
  name: "assessmentReportSlice",
  initialState: INIT_VALUE,
  reducers: {
    setAttemptType(state, action) {
      state.attemptType = action.payload;
    }
  }
});

export default AssessmentReportSlice;
export const AssessmentReportSliceActions = AssessmentReportSlice.actions;
